import { Highlightable } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { IAccount, UserService } from '../../shared/services/user.service';

@Component({
	selector: 'app-account-list-item',
	templateUrl: './account-list-item.component.html',
	styleUrls: ['./account-list-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AccountListItemComponent implements Highlightable {
	@Input() item;
	@Input() disabled = false;
	@Output() selected = new EventEmitter<IAccount>();
	private _isActive = false;
	selectedId: string;

	constructor(private userService: UserService) {
		this.userService.account$.subscribe((a) => {
			this.selectedId = a?.id;
		});
	}

	@HostBinding('class.active') get isActive() {
		return this._isActive;
	}

	setActiveStyles() {
		this._isActive = true;
	}

	setInactiveStyles() {
		this._isActive = false;
	}

	getLabel() {
		return this.item === undefined ? '' : this.item.name;
	}

	selectItem(item: IAccount) {
		this.selected.emit(item);
	}
}
